import script from "./UserNameAndGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./UserNameAndGroup.vue?vue&type=script&setup=true&lang=js"

import "./UserNameAndGroup.vue?vue&type=style&index=0&id=2b2c8fd6&scoped=true&lang=scss"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b2c8fd6"]])

export default __exports__